<template>
    <div>
        <Card dis-hover>
            <TreeChart
                :options="chartData"
                @click="showDetails" />
            <drawer :closable="true" placement="right" title="Nó" v-model="details" width="650">
                <tree-node v-model="node" :programadores="programadores" :tipos="tipos" />
                <Row v-if="permissoes.editar()" type="flex" justify="space-between" :gutter="16">
                    <i-col>
                        <Button type="error" @click="removeNode">Remover</Button>
                    </i-col>
                    <i-col>
                        <Button type="primary" @click="addNode">Novo nó</Button>
                    </i-col>
                    <i-col>
                        <Button type="success" @click="changeNode">Salvar</Button>
                    </i-col>
                </Row>
            </drawer>
        </Card>
    </div>
</template>

<script>
    export default {
        name: "arvore",
        components: {
            TreeChart: () => import("../components/charts/TreeChart.vue")
        },
        data() {
            return {
                details: false,
                node: {
                    tree_idx: 0,
                    id: 0,
                    nome: "",
                    descricao: "",
                    descricao_tecnica: "",
                    tipo: 1,
                    criticidade: 0,
                    owner_id: 0,
                    arquivos: "",
                    controllers: "",
                    metodos: "",
                },
                tipos: [
                    {
                        value: 1,
                        label: 'Módulo'
                    },
                    {
                        value: 2,
                        label: 'Função'
                    },
                    {
                        value: 3,
                        label: 'Funcionalidade'
                    },
                ],
                chartData: {
                    title : {
                        text: 'Bitis',
                        subtext: 'Árvore Sistema'
                    },
                    toolbox: {
                        show : true,
                        feature : {
                            mark : {show: true},
                            dataView : {show: true, readOnly: false},
                            restore : {show: true},
                            saveAsImage : {show: true}
                        }
                    },
                    tooltip: {
                        trigger: 'item',
                        triggerOn: 'mousemove',
                        formatter: (param) => param.data.nome,
                    },
                    legend: {
                        top: '2%',
                        left: '10%',
                        orient: 'vertical',
                        data: [
                            {
                            name: 'tree1',
                            icon: 'rectangle'
                            } ,
                            {
                                name: 'tree2',
                                icon: 'rectangle'
                            }
                        ],
                        borderColor: '#c23531'
                    },
                    series:[
                        {
                            type: 'tree',
                            data: [],

                            top: '2%',
                            left: '10%',
                            bottom: '2%',
                            right: '20%',

                            symbolSize: 10,

                            label: {
                                normal: {
                                    position: 'left',
                                    verticalAlign: 'middle',
                                    align: 'right',
                                    formatter: (param) => param.data.nome,
                                }
                            },

                            leaves: {
                                label: {
                                    normal: {
                                        position: 'right',
                                        verticalAlign: 'middle',
                                        align: 'left',
                                    },
                                }
                            },

                            expandAndCollapse: false,

                            animationDuration: 550,
                            animationDurationUpdate: 750

                        }
                    ]
                },
            }
        },
        computed: {
            permissoes() {
                return {
                    editar: () => {
                        /**
                         * Permissão: Administração
                         */
                        return [1, 11, 12, 29, 34].includes(this.cargo_user);
                    },
                }
            },
            cargo_user() {
                return this.$store.getters.usuario.usuario_cargo;
            },
            programadores() {
                return this.$store.getters['programadores']
                    .map(item => ({
                        value: item.id_pessoa,
                        label: item.nome
                    }));
            },
        },
        methods: {
            getTreeData(tree_idx = 0) {
                return this.chartData.series[tree_idx].data[0];
            },
            setTreeData(tree_idx, data) {
                if (data) {
                    this.chartData.series[tree_idx].data.splice(0, 1, data);
                } else {
                    this.chartData.series[tree_idx].data.splice(0, 1);
                }
            },
            async showDetails({data: {id, nome, descricao, descricao_tecnica, tipo, criticidade, owner, owner_id, arquivos, controllers, metodos}, seriesIndex}) {
                this.node.tree_idx = seriesIndex;
                this.node.id = id;
                this.node.nome = nome;
                this.node.descricao = descricao;
                this.node.descricao_tecnica = descricao_tecnica;
                this.node.tipo = tipo;
                this.node.criticidade = criticidade;
                this.node.owner_id = owner ? owner.id_pessoa : owner_id;
                this.node.arquivos = arquivos;
                this.node.controllers = controllers;
                this.node.metodos = metodos;

                this.details = true;
            },
            async changeNode() {
                try {
                    const node_id = this.node.id;
                    await this.$axios.put(
                        `tree/${node_id}`,
                        this.node
                    );
                    this.details = false;
                    const tree_idx = this.node.tree_idx;
                    this.setTreeData(tree_idx, this.changeElement(this.getTreeData(tree_idx), node_id));
                } catch (error) {
                    this.$Message.error(`Erro! ${error}`);
                }
            },
            changeElement(element, element_id) {
                if (element.id === element_id) {
                    element = Object.assign(element, this.node);
                } else if (element.children != null) {
                    for (let i = 0; i < element.children.length; i++) {
                        element.children[i] = this.changeElement(element.children[i], element_id);
                    }
                }
                return element;
            },
            async removeNode() {
                this.details = false;
                const node_id = this.node.id;
                const result = await this.confirmarRemocao(this.node.nome);
                if (!result) return;
                try {
                    await this.$axios.delete(`tree/${node_id}`);
                    const tree_idx = this.node.tree_idx;
                    this.setTreeData(tree_idx, this.removeElement(this.getTreeData(tree_idx), this.node.id));
                } catch (error) {
                    this.$Message.error(`Erro! ${error}`);
                }
            },
            removeElement(element, element_id) {
                if (element.id === element_id) {
                    if (element.children == null || element.children.length === 0) {
                        element = null;
                    }
                } else if (element.children != null) {
                    for (let i = 0; i < element.children.length; i++) {
                        const child = this.removeElement(element.children[i], element_id);
                        if (child) {
                            element.children[i] = child;
                        } else {
                            element.children.splice(i, 1);
                        }
                    }
                }
                return element;
            },
            async addNode() {
                const parent_id = this.node.id;
                try {
                    const childNode = await this.newNode(this.node);

                    const tree_idx = this.node.tree_idx;
                    this.setTreeData(tree_idx, this.changeTree(this.getTreeData(tree_idx), parent_id, childNode));
                } catch ({error}) {
                    this.$Message.error(`Erro! ${error}`);
                }
                this.details = false;
            },
            append (data, node) {
                const children = data.children || [];
                children.push(node);
                this.$set(data, 'children', children);
            },
            changeTree(element, parent_id, node) {
                if (element.id === parent_id) {
                    this.append(element, node);
                } else if (element.children != null) {
                    for (let i = 0; i < element.children.length; i++) {
                        element.children[i] = this.changeTree(element.children[i], parent_id, node);
                    }
                }
                return element;
            },
            async newNode(parent) {
                await this.$Modal.remove();
                return new Promise((resolve, reject) => {
                    let node = {
                        pai_id: parent.id,
                        nome: "",
                        descricao: "",
                        descricao_tecnica: "",
                        tipo: 0,
                        owner_id: null,
                        criticidade: 0,
                        arquivos: "",
                        controllers: "",
                        metodos: "",
                    };
                    this.$Modal.confirm({
                        closable: true,
                        title: `Novo nó para: ${parent.nome}`,
                        okText: "Confirmar",
                        cancelText: "Cancelar",
                        render: h => {
                            return h("tree-node",
                                {
                                    props: {
                                        tipos: this.tipos,
                                        programadores: this.programadores,
                                        value: node
                                    },
                                    on: {
                                        input: val => {
                                            node = val;
                                        }
                                    }
                                },
                            );
                        },
                        onOk: async () => {
                            if (node.nome.length < 3) {
                                reject({
                                    error: `Nome muito curto`,
                                    ...node
                                });
                                return;
                            }
                            try {
                                const { data } = await this.$axios.post('tree', node);
                                resolve(data);
                            } catch (error) {
                                reject({
                                    error,
                                    ...node
                                });
                            }
                        }
                    });
                });
            },
            async confirmarRemocao(nome) {
                await this.$Modal.remove();
                return new Promise((resolve, reject) => {
                    this.$Modal.confirm({
                        closable: true,
                        title: `Remover ${nome}?`,
                        okText: "Confirmar",
                        cancelText: "Cancelar",
                        onOk: async () => {
                            resolve(true);
                        },
                        onCancel: () => {
                            resolve(false);
                        }
                    });
                });
            },
            async getTree() {
                const { data } = await this.$axios.get('tree');
                this.setTreeData(0, data.data[0]);
            },
        },
        created() {
            this.getTree();
        }
    }
</script>

<style scoped>
    .echarts {
        width: 100%;
        height: 8000px;
    }
</style>
